import { Component, Input, OnInit, ViewChild, ChangeDetectorRef, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SidenavService } from '../../../services/util/sidenav.service';
import { Instance } from 'src/app/models/instance/instance';
import { BlueprintVersion } from 'src/app/models/blueprints/blueprint-version';
import { Constants } from 'src/app/models/constants';
import { KeyValueMap } from 'src/app/models/key-value-map';
import { PaginatorComponent } from 'src/app/components/paginator/paginator.component';
import { MatSort } from '@angular/material/sort';
import { GenericErrorComponent } from 'src/app/components/generic-error/generic-error.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-update-definition',
    templateUrl: './update-definition.component.html',
    styleUrls: ['./update-definition.component.scss'],
    standalone: false
})
export class UpdateDefinitionComponent implements OnInit {
  @ViewChild(MatSort, {static: true}) sort;
  @ViewChild(PaginatorComponent, { static: true }) paginator: PaginatorComponent;
  @Input() title: string;
  @Input() subtitle: string;
  @Input() instance: Instance;
  @Input() serviceName: string;
  @Input() set availableConfigurations(availableConfigurations: BlueprintVersion[]) {
    this.blueprintsVersionList = availableConfigurations !== undefined ? [...availableConfigurations] : [];
    this.blueprintsVersionList.sort(this.defaultComparator);
  }
private destroyRef = inject(DestroyRef);
  @Input() blueprintsVersionList: BlueprintVersion[];
  Constants = Constants;
  selection: BlueprintVersion;
  expandedRows: KeyValueMap<string, boolean> = {};

  pageConfigurations: BlueprintVersion[];
  filteredConfigurations: BlueprintVersion[];

  ascendingOrder = false;

  constructor(public sidenavService: SidenavService, private changeDetectorRef: ChangeDetectorRef, private matDialog: MatDialog) {
  }

  ngOnInit(): void {
    this.paginator.page
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(pageEvent => {
      const startIndex = pageEvent.pageIndex * pageEvent.pageSize;
      this.pageConfigurations = this.filteredConfigurations.slice(startIndex, startIndex + pageEvent.pageSize);
      if (!this.pageConfigurations.includes(this.selection)) {
        this.selection = null;
      }
      this.changeDetectorRef.detectChanges();
    });
    this.search();
  }

  search(value?: string): void {
    if(value) {
      const searchValue = value.toLowerCase();
      this.filteredConfigurations = this.blueprintsVersionList.filter(config =>
        config.version.toLowerCase().includes(searchValue) ||
        this.serviceName.toLocaleLowerCase().includes(searchValue));
    } else {
      this.filteredConfigurations = this.blueprintsVersionList;
    }

    // Clear selection when page is changed
    if (this.selection && !this.filteredConfigurations.includes(this.selection)) {
      this.selection = null;
    }

    this.paginator.length = this.filteredConfigurations.length;
  }

  select(row): void {
    this.selection = row;
  }

  expandRow(blueprintsVersionList: BlueprintVersion): void {
    this.expandedRows[blueprintsVersionList.id] = !this.expandedRows[blueprintsVersionList.id];
  }

  applyConfiguration(): void {
    const selectedConfiguration = this.selection;
    if (selectedConfiguration) {
      this.sidenavService.closeRightSidenav(selectedConfiguration);
    } else {
        this.matDialog.open(GenericErrorComponent, {
          minHeight: '342px',
          width: '566px',
          panelClass: 'flex-dialog'
        });
      }
  }

  sortData(event): void {
    this.sort = event;
    this.paginator.pageIndex = 0;
  }

  sortDateTime(): void {
    if(this.ascendingOrder){
      this.filteredConfigurations.sort((a,b) => a.dateCreated < b.dateCreated ? -1 : a.dateCreated > b.dateCreated ? 1 : 0);
      this.ascendingOrder = false;
    }else{
      this.filteredConfigurations.sort((a,b) => a.dateCreated < b.dateCreated ? 1 : a.dateCreated > b.dateCreated ? -1 : 0);
      this.ascendingOrder = true;
    }
    this.pageConfigurations = this.filteredConfigurations;
  }

  private defaultComparator(config1: BlueprintVersion, config2: BlueprintVersion): number {
    if (config1?.dateCreated && config2?.dateCreated) {
      return new Date(config2.dateCreated).getTime() - new Date(config1.dateCreated).getTime();
    }
    return 0;
  }

}
